function initSpQualityTabs(root){
 if(root.dataset.qualityReady)return;
 const tabs=[...root.querySelectorAll('[data-quality-tab]')];
 const panels=[...root.querySelectorAll('[data-quality-panel]')];
 if(tabs.length!==panels.length||!tabs.length)return;
 root.dataset.qualityReady='true';
 function select(index,focus=false){
  tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
  if(focus)tabs[index].focus({preventScroll:true});
 }
 tabs.forEach((tab,i)=>{
  tab.addEventListener('click',()=>select(i));
  tab.addEventListener('keydown',event=>{
   let next;
   if(event.key==='ArrowRight')next=(i+1)%tabs.length;
   else if(event.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=tabs.length-1;
   else return;
   event.preventDefault();select(next,true);
  });
 });
 select(0);root.classList.add('is-ready');
}
document.querySelectorAll('[data-quality-tabs]').forEach(initSpQualityTabs);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-quality-tabs]').forEach(initSpQualityTabs));
